import React from 'react';

interface SchemePreviewCardProps {
  eligibleUnits: string | number;
  freeProducts: string | number;
  unitType?: string;
}

export const SchemePreviewCard: React.FC<SchemePreviewCardProps> = ({
  eligibleUnits,
  freeProducts,
  unitType = 'Crates',
}) => {
  const unitsText = eligibleUnits && String(eligibleUnits).trim() !== '' ? eligibleUnits : '--';
  const freeText = freeProducts && String(freeProducts).trim() !== '' ? freeProducts : '--';

  return (
    <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm flex flex-col justify-between h-full min-h-[220px]">
      {/* Card Header */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <svg
              className="w-5 h-5 text-[#B71C1C]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
            <h3 className="font-bold text-gray-800 text-sm md:text-base">
              Scheme Preview
            </h3>
          </div>

          <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider">
            LIVE
          </span>
        </div>

        <p className="text-xs text-gray-400 font-medium mb-4">
          Customer sees:
        </p>

        {/* Live Preview Display Box */}
        <div className="bg-white border-2 border-red-200/80 rounded-2xl p-6 text-center shadow-2xs flex flex-col items-center justify-center my-2">
          <div className="text-base md:text-xl font-bold text-[#B71C1C] leading-snug">
            Buy {unitsText} {unitType},
          </div>
          <div className="text-base md:text-xl font-bold text-[#B71C1C] leading-snug mt-1">
            Get {freeText} Free Product
          </div>
        </div>
      </div>

      {/* Footer info */}
      <div className="flex items-center gap-1.5 text-xs text-gray-500 mt-3 pt-2">
        <svg
          className="w-4 h-4 text-[#B71C1C] shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
        <span className="text-gray-600 font-medium">Calculates automatically at checkout</span>
      </div>
    </div>
  );
};
